<div id="order_table" class="row no-gutters">
  <table mdbTable #tableEl="mdbTable" class="z-depth-1">
    <thead>
      <tr>
        <th scope="col" [mdbTableSort]="passes" sortBy="name">
          Pass Name<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="passes" sortBy="productType">
          Pass Type<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="passes" sortBy="scheduleType">
          Schedule Type<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="passes" sortBy="">
          Schedule<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="passes" sortBy="status">
          Status<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th class="th-button" scope="col">
          <div class="add-pass-container" [routerLink]="toPassForm">
            <div class="add-pass">Bundle</div>
          </div>
        </th>
        <th class="th-button" scope="col">
          <div class="add-pass-container" [routerLink]="toPassForm">
            <div class="add-pass">Pass</div>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let pass of passes; let i = index"
        [ngClass]="{ hidden: isHidden(pass) }"
      >
        <td
          *ngIf="show(i)"
          placement="bottom"
          [mdbPopover]="pass.description"
          [mdbPopoverHeader]="pass.name"
          triggers="hover"
        >
          {{ pass.name }}
        </td>
        <td *ngIf="show(i)">
          {{ pass.productTypeMask }}
        </td>
        <td *ngIf="show(i)">
          {{ pass.scheduleTypeMask }}
        </td>
        <td *ngIf="show(i)">
          {{ pass.schedule }}
        </td>
        <td *ngIf="show(i)" [ngClass]="{ error: isError(pass) }">
          {{ pass.status }}
        </td>
        <td *ngIf="show(i)">
          <a
            style="color: #429DFF"
            (click)="details(pass)"
            [routerLink]="toPassForm"
            ><img
              src="../../../assets/icons/edit.svg"
              style="width:15px;height:15px;margin-right: 5px;"
            /><u style="font-size: 15px;">Details</u></a
          >
        </td>
        <td *ngIf="show(i)">
          <a
            style="color: #429DFF"
            (click)="schedule(pass)"
            [routerLink]="toScheduleForm"
            ><img
              src="../../../assets/icons/edit.svg"
              style="width:15px;height:15px;margin-right: 5px;"
            /><u style="font-size: 15px;">Schedule</u></a
          >
        </td>
      </tr>
    </tbody>
  </table>
  <div class="d-flex flex-row no-gutters  align-items-center">
    <div class="chip" mdbDropdown>
      <div class="btn-group" mdbDropdownToggle>
        {{ filter.showing }}
        <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
      </div>
      <div class="dropdown-menu dropdown-primary">
        <a
          class="dropdown-item"
          *ngFor="let item of filter.itemsPerPage"
          (click)="setItemsPerPage(item)"
          >{{ item }}</a
        >
      </div>
    </div>
    <label>per page</label>
    <div class="example-spacer"></div>
    <label
      >{{ filter.firstIndex + 1 }} -
      {{ filter.lastIndex > passes.length ? passes.length : filter.lastIndex }}
      of
      {{ passes.length | number }}
    </label>

    <button (click)="decrement()">
      <i class="fas fa-chevron-left grey-text"></i>
    </button>
    <button (click)="increment()">
      <i class="fas fa-chevron-right grey-text"></i>
    </button>
  </div>
</div>
